import React, { useEffect, useState, useCallback, use } from "react";
import PageContainer from "../../../components/PageContainer";
import { useLocation } from 'react-router-dom';
import { MdOutlineArrowBack } from "react-icons/md";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PlanejamentoApiService from "../../../services/api/PlanejamentoApiService";
import Loading from "../../../components/Loading";
import { Table, Dropdown, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import ColaboradorApiService from "../../../services/api/ColaboradorApiService";
import ConvertDataService from "../../../services/util/ConvertDatas";
import UtilService from "../../../services/util";
import FuncaoApiService from "../../../services/api/FuncaoApiService";
import { FiInfo } from "react-icons/fi";
import RegimeApiService from "../../../services/api/RegimeApiService";
import RelatorioApiService from "../../../services/api/RelatorioApiService";


const popupStyle = {
    position: 'absolute',
    top: '-40%',
    left: '-600%',
    transform: 'translateX(-82%)',
    backgroundColor: '#e9e9e9',
    color: '#212529',
    border: '1px solid #dee2e6',
    borderRadius: '5px',
    padding: '5px 10px',
    zIndex: 1000,
    whiteSpace: 'nowrap',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: 'auto',
    fontWeight: 'normal'
};

function RelatorioCapacidadeView() {
    const location = useLocation();
    const { data } = location.state || {};
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [colaboradoresComHoras, setColaboradoresComHoras] = useState([]);
    const [filteredColaboradores, setFilteredColaboradores] = useState([]);
    const [ordenacaoColaborador, setOrdenacaoColaborador] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedRegime, setSelectedRegime] = useState('');
    const [visiblePopup, setVisiblePopup] = useState(null);
    const [visibleProjetoPopup, setVisibleProjetoPopup] = useState(null);
    const [sortDirection, setSortDirection] = useState({});
    const dataInicialFiltro = ConvertDataService.convertDataSplitYYYYmmDD(data.periodoInicial);
    const dataFinalFiltro = ConvertDataService.convertDataSplitYYYYmmDD(data.periodoFinal);

    useEffect(() => {
        setLoading(true)
        RelatorioApiService.getRelatorioCapacidadeArea(dataInicialFiltro, dataFinalFiltro).then(res => {
            setColaboradoresComHoras(res.data);
            setLoading(false)
        });
    }, [])

    //filtros por departamento e regime
    useEffect(() => {
        const filtered = colaboradoresComHoras.filter((item) => {
            const matchesDepartment = selectedDepartment
                ? item.colaborador.departamento.cod == (selectedDepartment == 'Delivery' ? 5 : selectedDepartment == 'ENGESOL' ? 16 : "-")
                : true;
            const matchesRegime = selectedRegime
                ? item.colaborador.regime.cod == (selectedRegime == 'CLT' ? 1 : 3)
                : true;
            return matchesDepartment && matchesRegime;
        });
        setFilteredColaboradores(filtered);
    }, [selectedDepartment, selectedRegime, colaboradoresComHoras]);

    useEffect(() => {
        setOrdenacaoColaborador(filteredColaboradores.sort((a, b) => a.colaborador.nome.localeCompare(b.colaborador.nome)));
    }, [filteredColaboradores])

    //excel
    const exportDataInExcel = async () => {
        const header = [
            [
            'Colaborador', 'Status', 'Departamento', 'Regime', 'Função', 'Perfil',
            'Classificação', 'Carga Horária Diária (h)', 'Total Horas Obrigatórias (h)',
            'Total Horas Planejadas (h)', 'Total horas de Férias (h)', 'Horas Livres Planejadas (h)',
            'Ocupação Planejada(%)', 'Total de Horas Realizadas (h)', 'Ocupação Realizada (%)',
            'Total de Horas Faturáveis (h)', 'Ocupação Faturável (%)', 'Variação Faturável (%)',
            'Horas Planejadas por Projeto'
            ]
        ];

        const formatedData = filteredColaboradores.map(item => {
            const lista = Array.isArray(item.horasPlanejadasPorProjeto)
            ? item.horasPlanejadasPorProjeto
            : [];

            const textoProjetos = lista.length === 0
                ? ''
                : lista
                    .filter(p => {
                        return !(p?.cliente == null && p?.projeto == null);
                    })
                    .map(p => {
                        const clienteKey = p?.cliente?.clienteKey;
                        const projetoKey = p?.projeto;

                        let label = '';

                        if (clienteKey && projetoKey) {
                        label = `${clienteKey}/${projetoKey}`;
                        } else if (projetoKey) {
                        label = projetoKey;
                        } else {
                        return null;
                        }

                        return `${label} ${p?.horas}h`;
                    })
                    .filter(Boolean)
                    .join(', ');


            return {
            colaborador: `${item.colaborador.nome} ${item.colaborador.sobrenome}`,
            status: item.colaborador.demissao ? "Inativo" : "Ativo",
            departamento: item.colaborador.departamento.nome,
            regime: item.colaborador.regime.nome,
            funcao: item.colaborador.funcao.nome,
            perfil: `${item.perfil}`,
            classificacao: `${item.infoMaiorAlocacao.categoria}`,
            cargaHorariaDiaria: item.horasPorDia,
            totalHorasObrigatorias: item.totalHorasObrigatorias,
            totalHorasPlanejadas: item.totalHorasPlanejadas,
            totalHorasFerias: item.ferias,
            horasLivres: item.horasLivres,
            ocupacaoPlanejada: item.colaborador.demissao ? "--" : item.ocupacao.ocupacaoPlanejada,
            totalHorasRealizadas: item.horasRealizadas,
            ocupacaoRealizada: item.ocupacao.ocupacaoRealizada,
            totalHorasFaturaveis: item.horasFaturaveis,
            ocupacaoFaturavel: item.ocupacao.ocupacaoFaturavel,
            variacaoFaturavel: item.variacaoFaturavel,
            horasPlanejadasPorProjeto: textoProjetos
            };
        });

        UtilService.exportXls(
            formatedData,
            `Relatório Capacidade: ${data.periodoInicial} - ${data.periodoFinal}`,
            header
        );
    };

    //ordenacao
    const handleOrdenar = (key) => {
        let direction = sortDirection[key] || "cima";
        direction = direction === "cima" ? "baixo" : "cima";
        setSortDirection({ ...sortDirection, [key]: direction });

        const comparators = {
            colaborador: (a, b) => a.colaborador.nome.localeCompare(b.colaborador.nome),
            departamento: (a, b) => a.colaborador.departamento.nome.localeCompare(b.colaborador.departamento.nome),
            regime: (a, b) => a.colaborador.regime.nome.localeCompare(b.colaborador.regime.nome),
            funcao: (a, b) => a.colaborador.funcao.nome.localeCompare(b.colaborador.funcao.nome),
            perfil: (a, b) => a.perfil.localeCompare(b.perfil),
            classificacao: (a, b) => (a.infoMaiorAlocacao?.categoria || "").localeCompare(b.infoMaiorAlocacao?.categoria || ""),
            cargaHoraria: (a, b) => a.horasPorDia - b.horasPorDia,
            ocupacaoPlanejada: (a, b) => a.ocupacao.ocupacaoPlanejada - b.ocupacao.ocupacaoPlanejada,
            horasObrigatorias: (a, b) => a.totalHorasObrigatorias - b.totalHorasObrigatorias,
            horasLivres: (a, b) => a.horasLivres - b.horasLivres,
            horasPlanejadas: (a, b) => a.totalHorasPlanejadas - b.totalHorasPlanejadas,
            horasFerias: (a, b) => a.ferias - b.ferias,
            horasRealizadas: (a, b) => a.horasRealizadas - b.horasRealizadas,
            ocupacaoRealizada: (a, b) => a.ocupacao.ocupacaoRealizada - b.ocupacao.ocupacaoRealizada,
            horasFaturaveis: (a, b) => a.horasFaturaveis - b.horasFaturaveis,
            ocupacaoFaturavel: (a, b) => a.ocupacao.ocupacaoFaturavel - b.ocupacao.ocupacaoFaturavel,
            variacaoFaturavel: (a, b) => a.variacaoFaturavel === "-" ? 0 : parseFloat(a.variacaoFaturavel.replace('%', '')) - (b.variacaoFaturavel === "-" ? 0 : parseFloat(b.variacaoFaturavel.replace('%', ''))) 
        };

        const sortedColaboradores = [...filteredColaboradores].sort((a, b) => {
            const comparator = comparators[key];
            if (!comparator) return 0;
            return direction === "cima" ? comparator(a, b) : comparator(b, a);
        });

        setOrdenacaoColaborador(sortedColaboradores);
    };

    const SortIcon = ({ column, sortDirection }) => {
        if (!sortDirection[column]) {
            return <FaSort className="ml-1" style={{ opacity: 0.3 }} />;
        }
        return sortDirection[column] === "cima" ?
            <FaSortUp className="ml-1" /> :
            <FaSortDown className="ml-1" />;
    };

    const totalHorasPlanejadas = filteredColaboradores.reduce((total, item) => {
        return total + item.totalHorasPlanejadas;
    }, 0);

    const totalHorasObrigatorias = filteredColaboradores.reduce((total, item) => {
        return total + item.totalHorasObrigatorias;
    }, 0)

    const totalHorasRealizadas = filteredColaboradores.reduce((total, item) => {
        return total + item.horasRealizadas;
    }, 0)

    const totalHorasFaturaveis = filteredColaboradores.reduce((total, item) => {
        return total + item.horasFaturaveis;
    }, 0)

    const totalHorasFerias = filteredColaboradores.reduce((total, item) => {
        return total + item.ferias;
    }, 0);

    const totalHorasLivres = filteredColaboradores.reduce((total, item) => {
        return total + item.horasLivres;
    }, 0)

    const riscoDemissao = {
        textDecoration: "line-through"
    }

    const handleProjetoMouseEnter = (projetoId) => {
        setVisibleProjetoPopup(projetoId);
    };

    const handleProjetoMouseLeave = () => {
        setVisibleProjetoPopup(null);
    };

    const getProjetoPopupStyle = (isFirstRow) => {
        const baseStyle = {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#ffffff',
            color: '#212529',
            border: '1px solid #dee2e6',
            borderRadius: '6px',
            padding: '10px 14px',
            zIndex: 1000,
            boxShadow: 'rgba(0, 0, 0, 0.12) 0px 2px 8px 0px',
            minWidth: '180px',
            maxWidth: '250px',
            fontSize: '12px',
            lineHeight: '1.5',
            whiteSpace: 'normal',
            pointerEvents: 'none',
        };

        if (isFirstRow) {
            // Primeira linha da tabela: pop-up abaixo
            return {
                ...baseStyle,
                top: '100%',
                marginTop: '6px',
            };
        } else {
            // Demais linhas: pop-up acima
            return {
                ...baseStyle,
                bottom: '100%',
                marginBottom: '6px',
            };
        }
    };

    const horasPlanejadasPorProjeto = (item, rowIndex) => {
        if (!item.horasPlanejadasPorProjeto || !Array.isArray(item.horasPlanejadasPorProjeto)) {
            return '';
        }

        const projetos = item.horasPlanejadasPorProjeto.filter(p => p.projeto);

        if (projetos.length === 0) {
            return '';
        }

        return (
            <span style={{ display: 'inline-flex', gap: '4px' }}>
                {projetos.map((p, index) => {
                    const projetoId = `projeto-${rowIndex}-${index}`;
                    const clienteNome = p.cliente?.clienteKey || 'N/A';
                    const projetoNome = p.projeto || 'N/A';
                    const horas = p.horas || 0;
                    const isFirstRow = rowIndex === 0;

                    return (
                        <span
                            key={projetoId}
                            style={{
                                position: 'relative',
                                display: 'inline-block',
                                cursor: 'pointer',
                                padding: '2px 4px',
                                borderRadius: '4px',
                                backgroundColor: '#f8f9fa',
                                border: '1px solid #e9ecef',
                                marginRight: '4px',
                            }}
                            onMouseEnter={() => handleProjetoMouseEnter(projetoId)}
                            onMouseLeave={handleProjetoMouseLeave}
                        >
                            {projetoNome}
                            {visibleProjetoPopup === projetoId && (
                                <div style={getProjetoPopupStyle(isFirstRow)}>
                                    {clienteNome !== 'N/A' && (
                                        <div style={{ marginBottom: '6px' }}>
                                            <span style={{ color: '#6c757d', fontSize: '11px' }}>Cliente: </span>
                                            <span style={{ fontWeight: '500' }}>{clienteNome}</span>
                                        </div>
                                    )}
                                    {projetoNome !== 'N/A' && (
                                        <div style={{ marginBottom: '6px' }}>
                                            <span style={{ color: '#6c757d', fontSize: '11px' }}>Projeto: </span>
                                            <span style={{ fontWeight: '500' }}>{projetoNome}</span>
                                        </div>
                                    )}
                                    {horas && (
                                        <div>
                                            <span style={{ color: '#6c757d', fontSize: '11px' }}>Horas: </span>
                                            <span style={{ fontWeight: '600', color: '#28a745' }}>{horas}h</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </span>
                    );
                })}
            </span>
        );
    }

    const handleCancel = () => {
        history.push('../relatorios-delivery/');
    };

    const actions = [
        {
            label: 'Voltar',
            icon: <MdOutlineArrowBack />,
            color: 'info',
            type: 'button',
            onClick: handleCancel
        }
    ];

    const fixarTitulo = {
        "position": "sticky",
        "top": 0,
        "zIndex": 9998,
        "backgroundColor": "#f5f5f5",
    }

    const fixarThead = {
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "#f5f5f5",
        "boxShadow": " 0 4px 4px -4px rgba(0, 0, 0, 0.3)"
    }

    const handleMouseEnter = (popupId) => {
        setVisiblePopup(popupId);
    };

    const handleMouseLeave = () => {
        setVisiblePopup(null);
    };

    return (
        <>
            <div style={fixarTitulo}>
                <PageContainer title={"Relatório Capacidade da Área"} actions={actions}>
                    <h5>Período Inicial: {data.periodoInicial}</h5>
                    <h5 className="mb-4">Período Final: {data.periodoFinal}</h5>

                    <div className="d-flex mb-3" style={{ position: "sticky" }}>
                        <Button onClick={() => exportDataInExcel()} className='mr-3'>Exportar</Button>
                        <Dropdown className="mr-3">
                            <Dropdown.Toggle variant="light" id="dd-column">
                                Filtrar por Departamento: <span style={{ fontWeight: 'bold' }}>{selectedDepartment ? selectedDepartment : "Todos"}</span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setSelectedDepartment('Delivery')}>
                                    Delivery
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setSelectedDepartment('ENGESOL')}>
                                    ENGESOL
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setSelectedDepartment('Overhead')}>
                                    Overhead
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setSelectedDepartment('')}>
                                    Todos
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Dropdown.Toggle variant="light" id="dd-column">
                                Filtrar por Regime: <span style={{ fontWeight: 'bold' }}>{selectedRegime ? selectedRegime : "Todos"}</span>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setSelectedRegime('CLT')}>
                                    CLT
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setSelectedRegime('Estagiário')}>
                                    Estagiário
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => setSelectedRegime('')}>
                                    Todos
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </PageContainer>
            </div>
            {loading ? <Loading message={"Carregando..."} /> :
                <div id="tabela-personalizada-relatorio-capacidade" style={{ overflowY: "auto", height: "calc(100vh - 220px)" }}>
                    <Table striped bordered hover responsive="xl">
                        <thead style={fixarThead}>
                            <tr>
                                <th className="fixed-column no-wrap" onClick={() => handleOrdenar("colaborador")}>Colaborador <SortIcon column="colaborador" sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar("departamento")}>Departamento <SortIcon column="departamento" sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar("regime")}>Regime do contrato <SortIcon column="regime" sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar("funcao")}>Função <SortIcon column="funcao" sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar("perfil")}>Perfil <SortIcon column="perfil" sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar("classificacao")}> Classificação
                                    <span
                                        onMouseEnter={() => handleMouseEnter('classificacao')}
                                        onMouseLeave={handleMouseLeave}
                                        className="ml-1 info-icon"
                                        style={{ position: 'relative', cursor: 'pointer' }}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'classificacao' && (
                                            <div className="hover-popup" style={popupStyle}>
                                                Classificação do projeto em que o colaborador tem a maior alocação prevista.
                                            </div>
                                        )}
                                    </span>
                                    <SortIcon column="classificacao" sortDirection={sortDirection} /> </th>
                                <th className="no-wrap" onClick={() => handleOrdenar("cargaHoraria")}>Cargas horárias <br /> diárias <SortIcon column="cargaHoraria" sortDirection={sortDirection} /></th>
                                <th className="no-wrap" onClick={() => handleOrdenar("horasObrigatorias")}>Total horas <br /> Obrigatórias <SortIcon column="horasObrigatorias" sortDirection={sortDirection} /></th>
                                <th className="no-wrap verde-claro-planejado" onClick={() => handleOrdenar("horasPlanejadas")}>Total horas <br /> Planejadas
                                    <span
                                        onMouseEnter={() => handleMouseEnter('total_planejadas')}
                                        onMouseLeave={handleMouseLeave}
                                        className="ml-1 info-icon"
                                        style={{ position: 'relative', cursor: 'pointer' }}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'total_planejadas' && (
                                            <div className="hover-popup" style={popupStyle}>
                                                Total de horas planejadas (campo 'Horas planejadas') em projetos de clientes.
                                            </div>
                                        )}
                                    </span>
                                    <SortIcon column="horasPlanejadas" sortDirection={sortDirection} />
                                </th>
                                <th className="no-wrap verde-claro-planejado" onClick={() => handleOrdenar("horasFerias")}>Total horas de <br /> Férias <SortIcon column="horasFerias" sortDirection={sortDirection} /></th>
                                <th className="no-wrap verde-claro-planejado" onClick={() => handleOrdenar("horasLivres")}>Horas Livres <br /> Planejadas <SortIcon column="horasLivres" sortDirection={sortDirection} /></th>
                                <th className="no-wrap verde-claro-planejado" onClick={() => handleOrdenar("ocupacaoPlanejada")}>Ocupação <br /> Planejada (%) <SortIcon column="ocupacaoPlanejada" sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar("horasRealizadas")}>Total horas <br /> Realizadas
                                    <span
                                        onMouseEnter={() => handleMouseEnter('total_realizadas')}
                                        onMouseLeave={handleMouseLeave}
                                        className="ml-1 info-icon"
                                        style={{ position: 'relative', cursor: 'pointer' }}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'total_realizadas' && (
                                            <div className="hover-popup" style={popupStyle}>
                                                Total de horas trabalhadas (campo 'Duração') em projetos de clientes.
                                            </div>
                                        )}
                                    </span>
                                    <SortIcon column="horasRealizadas" sortDirection={sortDirection} />
                                </th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar("ocupacaoRealizada")}>Ocupação <br /> Realizada (%) <SortIcon column="ocupacaoRealizada" sortDirection={sortDirection} /></th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar("horasFaturaveis")}>Total horas <br /> Faturáveis
                                    <span
                                        onMouseEnter={() => handleMouseEnter('total_faturaveis')}
                                        onMouseLeave={handleMouseLeave}
                                        className="ml-1 info-icon"
                                        style={{ position: 'relative', cursor: 'pointer' }}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'total_faturaveis' && (
                                            <div className="hover-popup" style={popupStyle}>
                                                Total de horas faturáveis (campo 'Horas faturáveis') em projetos de clientes.
                                            </div>
                                        )}
                                    </span>
                                    <SortIcon column="horasFaturaveis" sortDirection={sortDirection} />
                                </th>
                                <th className="no-wrap azul-claro-realizado" onClick={() => handleOrdenar("ocupacaoFaturavel")}>Ocupação <br /> Faturável (%) <SortIcon column="ocupacaoFaturavel" sortDirection={sortDirection} /></th>
                                <th className="no-wrap cinza-claro-variacao" onClick={() => handleOrdenar("variacaoFaturavel")}>Variação <br /> Faturável (%)
                                    <span
                                        onMouseEnter={() => handleMouseEnter('variacao_faturavel')}
                                        onMouseLeave={handleMouseLeave}
                                        className="ml-1 info-icon"
                                        style={{ position: 'relative', cursor: 'pointer' }}
                                    >
                                        <FiInfo />
                                        {visiblePopup === 'variacao_faturavel' && (
                                            <div className="hover-popup" style={popupStyle}>
                                                Diferença entre total de horas planejadas e o total de horas faturáveis.
                                            </div>
                                        )}
                                    </span>
                                    <SortIcon column="variacaoFaturavel" sortDirection={sortDirection} />
                                </th>
                                <th className="no-wrap cinza-claro-variacao">Horas Planejadas por Projetos</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ordenacaoColaborador
                                .map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="fixed-column no-wrap" style={item.colaborador.demissao ? riscoDemissao : {}}>{item.colaborador.nome} {item.colaborador.sobrenome} </td>
                                            <td className="no-wrap">{item.colaborador.departamento.nome}</td>
                                            <td className="no-wrap">{item.colaborador.regime.nome}</td>
                                            <td className="no-wrap">{item.colaborador.funcao.nome}</td>
                                            <td className="no-wrap">{item.perfil}</td>
                                            <td className="no-wrap"> {item.infoMaiorAlocacao.categoria}</td>
                                            <td className="no-wrap">{item.horasPorDia}h</td>
                                            <td className="no-wrap">{item.totalHorasObrigatorias}h</td>
                                            <td className="no-wrap verde-claro-planejado">{item.totalHorasPlanejadas > 0 ? item.totalHorasPlanejadas : 0}h</td>
                                            <td className="no-wrap verde-claro-planejado">{item.ferias}h</td>
                                            <td className={`no-wrap verde-claro-planejado ${item.horasLivres < 0 && "text-danger"}`}>{item.horasLivres}h</td>
                                            <td className="no-wrap verde-claro-planejado">{item.colaborador.demissao ? "-- " : item.ocupacao.ocupacaoPlanejada}%</td>
                                            <td className="no-wrap azul-claro-realizado">{item.horasRealizadas}h</td>
                                            <td className="no-wrap azul-claro-realizado">{item.ocupacao.ocupacaoRealizada}%</td>
                                            <td className="no-wrap azul-claro-realizado">{item.horasFaturaveis}h</td>
                                            <td className="no-wrap azul-claro-realizado">{item.ocupacao.ocupacaoFaturavel}%</td>
                                            <td className="no-wrap cinza-claro-variacao">{item.variacaoFaturavel}%</td>
                                            <td className="no-wrap verde-claro-planejado">{horasPlanejadasPorProjeto(item, index)}</td>
                                        </tr>
                                    )
                                })}
                            <tr>
                                <td className="fixed-column no-wrap"><strong>Total de colaboradores: {filteredColaboradores.length}</strong></td>
                                <td></td>
                                <td></td>
                                <td className="no-wrap"></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td className="no-wrap"><strong>{totalHorasObrigatorias.toFixed()}h</strong></td>
                                <td className="no-wrap verde-claro-planejado"><strong>{totalHorasPlanejadas.toFixed()}h</strong></td>
                                <td className="no-wrap verde-claro-planejado"><strong>{totalHorasFerias.toFixed()}h</strong></td>
                                <td className="no-wrap verde-claro-planejado"><strong>{Math.floor(totalHorasLivres)}h</strong></td>
                                <td className="no-wrap verde-claro-planejado"><strong>{isNaN(((totalHorasPlanejadas * 100) / totalHorasObrigatorias).toFixed()) ? "0" : ((totalHorasPlanejadas * 100) / totalHorasObrigatorias).toFixed()}%</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{totalHorasRealizadas.toFixed()}h</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{isNaN(((totalHorasRealizadas * 100) / totalHorasObrigatorias).toFixed()) ? "0" : ((totalHorasRealizadas * 100) / totalHorasObrigatorias).toFixed()}%</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{totalHorasFaturaveis.toFixed()}h</strong></td>
                                <td className="no-wrap azul-claro-realizado"><strong>{isNaN(((totalHorasFaturaveis * 100) / totalHorasObrigatorias).toFixed()) ? "0" : ((totalHorasFaturaveis * 100) / totalHorasObrigatorias).toFixed()}%</strong></td>
                                <td className="no-wrap cinza-claro-variacao">
                                    <strong>
                                        {(() => {                              
                                            const desvio = totalHorasPlanejadas === 0
                                            ? (totalHorasFaturaveis === 0 ? 0 : -100)
                                            : ((totalHorasPlanejadas - totalHorasFaturaveis) / totalHorasPlanejadas) * 100;
                                            return `${desvio.toFixed() == -0 ? 0 : desvio.toFixed()}%`;
                                        })()}
                                    </strong>
                                </td>
                                <td className="no-wrap verde-claro-planejado"></td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            }
        </>
    );
}

export default RelatorioCapacidadeView;